<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="!isEdicao">Cadastrar cortesia</h5>
      <h5 class="modal-title" v-else>Editar cortesia</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-key"></i>Dados da Cortesia</h6>
      <div class="row">

        <div class="col-12 col-md-6" v-if="!isEdicao &&!cortesia.lista_emails">
          <form-group id="emailCortesia"  label="Email *" :text="{ required: 'Obrigatório informar o email da cortesia' }" :field="$v.cortesia.email">
            <input type="text" class="form-control" id="email" placeholder="" v-model="cortesia.email" value="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6" v-if="isEdicao">
          <form-group id="emailCortesia"  label="Email *" :text="{ required: 'Obrigatório informar o email da cortesia' }" :field="$v.cortesia.email">
            <input type="text" class="form-control" id="email" placeholder="" v-model="cortesia.email" readonly/>
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="tipoCortesiaDesc" label="Tipo da cortesia" :text="{ required: 'Obrigatório informar a descrição da cortesia' }" :field="$v.cortesia.tipo_cortesia_id">
            <select class="form-control" v-model="cortesia.tipo_cortesia_id">
              <option v-for="tipo in tipos_cortesias" :value="tipo.id">{{tipo.descricao}}</option>
            </select>
          </form-group>
        </div>

        <div class="col-12 col-md-6">
          <form-group id="tipoCortesiaObs"  label="Observação da cortesia" :text="{ required: 'Obrigatório informar a observação da cortesia' }" :field="$v.cortesia.observacao">
            <input type="text" class="form-control" id="obs_cortesia" placeholder="" v-model="cortesia.observacao" />
          </form-group>
        </div>

        <div class="col-12 col-md-6" v-if="!isEdicao">
          <form-group id="planoCortesia" label="Planos da cortesia" :text="{ required: 'Obrigatório informar o plano da cortesia' }" :field="$v.cortesia.planos_ids">
            <multiselect v-model="arrayPlanosIds" :options="tipos_planos" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecione um plano" label="nome" track-by="nome" select-label="Selecionar plano" deselect-label="Remover plano" selected-label="Plano selecionado" :preselect-first="true" :block-keys="['Tab','Enter']">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} planos selecionados</span>
              </template>
            </multiselect>
          </form-group>
        </div>

        <div class="col-12 col-md-6" v-if="isEdicao">
          <form-group id="planoCortesiaEditar" label="Plano da cortesia" :text="{ required: 'Obrigatório informar o plano da cortesia' }" :field="$v.cortesia.plano_id">
            <select class="form-control" v-model="cortesia.plano_id">
              <option v-for="tipo in tipos_planos" :value="tipo.planos[0].id">{{tipo.nome}}</option>
            </select>
          </form-group>
        </div>

      </div>
      <div v-if="!isEdicao && !cortesia.email">
        <h6><i class="fas fa-file-import"></i> Importação de lista de e-mails</h6>

        <div class="row">
          <div class="col-12 col-md">
            <a :href="baseFile">Download arquivo template</a>
          </div>

          <div class="form-group col-12 col-md-6">
            <label for="importar-lista" class="sr-only">Importar lista de cortesias</label>
            <input type="file" class="form-control-file" id="importar-lista" ref="file" v-on:change="handleFileUpload">
          </div>
        </div>
      </div>

      <h6><i class="fas fa-user-tag"></i> Tipo de disponibilidade</h6>

      <div class="row">
        <div class="col-12 col-md-6">
          <form-group id="fimValidadeCortesia"  label="Válido até *" :text="{ required: 'Obrigatório informar o final da validade' }" :field="$v.cortesia.data_validade">
            <input v-if="isSafari" type="date" v-mask="['##/##/####']" class="form-control" id="data_validade" placeholder="dd/mm/aaaa" v-model="cortesia.data_validade" />
            <input v-else type="date" class="form-control" id="data_validade" placeholder="" v-model="cortesia.data_validade" />
          </form-group>
        </div>
      </div>

      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarCortesia" v-if="isEdicao">Salvar</button>
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarCortesia" v-else>Cadastrar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import CortesiaAPI from '@/api/cortesia-api'
import { required, requiredIf } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import DateUtils, { DateConstants } from '@/core/util/date-utils'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import UrlUtils from '@/core/util/url-utils'

export default {
  name: 'ModalCadastroCortesia',
  components: {
    FormGroup,
    Multiselect
  },
  props: {
    cortesiaEdicao: Object,
    tipos_cortesias: Array,
    tipos_planos: Array
  },
  data () {
    return {
      cortesia: {
        email: '',
        tipo_cortesia_id: '',
        planos_ids: [],
        plano_id: '',
        observacao: '',
        data_validade: '',
        lista_emails: null
      },
      arrayPlanosIds: []
    }
  },

  computed: {
    isSafari: function () {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('safari') !== -1) {
        if (ua.indexOf('chrome') > -1) {
          return false
        } else {
          return true
        }
      }
      return false
    },

    isEdicao: function () {
      return this.cortesiaEdicao && this.cortesiaEdicao.id > 0
    },
    isRequired: function () {
      return this.isEdicao ? '{ }' : '{ required }'
    },
    listaPlanosIds: function () {
      let arrayPlanoId = []
      this.arrayPlanosIds.map(plano => {
        plano.planos.length > 0 &&
        arrayPlanoId.push(plano.planos[0].id)
      })
      return arrayPlanoId
    },

    baseFile: function () {
      return UrlUtils.obterUrlS3('modelo_importacao/import_cortesias_template.csv')
    }
  },

  watch: {
    'cortesia.email': function () {
      this.cortesia.lista_emails = null
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      if (this.cortesiaEdicao) {
        this.cortesia = Object.assign({}, this.cortesiaEdicao)
        if (this.isSafari) {
          this.cortesia.data_validade = moment(this.cortesiaEdicao.data_validade).format('DD/MM/YYYY')
        } else {
          this.cortesia.data_validade = DateUtils.formatDate(DateUtils.parse(this.cortesiaEdicao.data_validade), DateConstants.YYYY_MM_DD)
        }
      } else {
        this.cortesia = {
          email: '',
          tipo_cortesia_id: '',
          planos_ids: [],
          observacao: '',
          data_validade: '',
          lista_emails: null
        }
      }
    })
  },

  validations: {
    cortesia: {
      email: {
        required: requiredIf(function (cortesia) {
          return !cortesia.lista_emails
        })
      },
      tipo_cortesia_id: { required },
      planos_ids: { },
      plano_id: { },
      observacao: { },
      data_validade: { required },
      lista_emails: {
        required: requiredIf(function (cortesia) {
          return !cortesia.email
        })
      }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },

    cadastrarCortesia: function () {
      this.$v.cortesia.$touch()
      if (!this.$v.cortesia.$invalid) {
        const loader = this.$loading.show()

        this.cortesia.planos_ids = this.listaPlanosIds
        let cortesia = this.cortesia
        if (this.isSafari) {
          cortesia.data_validade = moment(this.cortesia.data_validade, 'DD/MM/YYYY').format('YYYY-DD-MM')
        }

        CortesiaAPI.salvar(cortesia).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Cortesia criado com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('cortesiaSalva', this.cortesia)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    editarCortesia: function () {
      this.$v.cortesia.$touch()
      if (!this.$v.cortesia.$invalid) {
        const loader = this.$loading.show()
        let cortesia = this.cortesia
        if (this.isSafari) {
          cortesia.data_validade = moment(this.cortesia.data_validade, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }

        CortesiaAPI.editar(cortesia).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Cortesia atualizado com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('cortesiaSalva', this.cortesia)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    handleFileUpload: function () {
      this.cortesia.lista_emails = this.$refs.file.files[0]
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
